import JobPostingEdit from "../Edits/JobPostingEdit";
import CmModal from "../Controls/CmModal";

export default function JobPostingEditModal({
  jobPostingId = 0,
  employerId = 0,
  employerName = "",
  roleId = 0,
  roles = [],
  packages = [],
  onClose,
}) {
  const id = Number.parseInt(jobPostingId, 10) || 0;
  const title = (
    <>
      {id > 0 ? "Job Posting" : "Add Job Posting"}
      {id > 0 ? <span className="cm-modal-dialog__title-id">{id}</span> : null}
    </>
  );

  return (
    <CmModal
      open
      bare
      onClose={onClose}
      title={title}
      size="xl"
      testId="job-posting-edit-modal"
    >
      <JobPostingEdit
        jobPostingId={id}
        employerId={employerId}
        employerName={employerName}
        roleId={roleId}
        roles={roles}
        packages={packages}
        onClose={onClose}
      />
    </CmModal>
  );
}
